import { render, staticRenderFns } from "./topBoxT.vue?vue&type=template&id=63d35200&scoped=true"
import script from "./topBoxT.vue?vue&type=script&lang=js"
export * from "./topBoxT.vue?vue&type=script&lang=js"
import style0 from "./topBoxT.vue?vue&type=style&index=0&id=63d35200&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d35200",
  null
  
)

export default component.exports